import React, {
    useCallback,
    useEffect,
    useState,
    useRef
} from 'react'

import { connect } from 'react-redux'

import FileDisplay from 'components/file/file-display'
import LoadMore from 'components/load-more/load-more'
import AlertBanner from 'components/alerts/alert-banner'

import {
    openModal,
    getChatVersions
} from 'state/actions'

import {
    formatByTimeZone,
    formatStandardDateTime,
} from 'utils'

const BigChatFiles = ({
    chat,
    openModal,
    getChatVersions,
    allVersions,
    allFiles
}) => {
    const [total, setTotal] = useState(0)
    const [offset, setOffset] = useState(0)
    const [isLoadingInitial, setIsLoadingInitial] = useState(true)
    const [isLoadingMore, setIsLoadingMore] = useState(false)

    const versions = ((chat && chat.versions) ? chat.versions.map(versionId => {
        const version = allVersions[versionId]

        if (!version || version.deleted_at) {
            return
        }

        const file = allFiles[version.file_id]

        if (!file || file.deleted_at) {
            return
        }

        return {
            ...version,
            file
        }
    }).filter(Boolean) : []).sort((a,b) => {
        return b.id - a.id
    })

    const versionsRef = useRef(versions)
    versionsRef.current = versions

    const chatObjectId = useRef(chat ? chat.id : null)

    const fetch = () => {
        setIsLoadingMore(true)

        getChatVersions(chat.id, offset, ({
            totals
        }) => {
            setIsLoadingMore(false)
            setIsLoadingInitial(false)

            setTotal(totals)
            setOffset(offset + 10)
        })
    }

    useEffect(() => {
        fetch()
    }, [])

    useEffect(() => {
        if (chat && chat.id && chat.id !== chatObjectId.current) {
            chatObjectId.current = chat.id

            setTotal(0)
            setOffset(0)

            fetch()
        }

    }, [chat])

    const handleLoadMore = () => {
        fetch()
    }

    const openPreviewModal = useCallback(version => {
        const startIndex = versions.findIndex(loopedVersion => {
            return loopedVersion.id === version.id
        })

        openModal('preview', 'files', {
            versions,
            startIndex
        })
    }, [versions])

    const _versions = isLoadingInitial ? new Array(4).fill({
        file: null,
        isLoading: true
    }) : versions

    const getRandomNameByIndex = index => {
        switch (index) {
            case 0:
                return 'XXX XXXXXXXXX'
            case 1:
                return 'XXXXXXX'
            case 2:
                return 'XXXXXXX XXXXXXXX'
            case 3:
                return 'XXXXXX XXXXX XXXXX'
            case 4:
                return 'XXXX XXXXXX'
        }
    }

    return (
        <div className='big-chat-files'>
            <h3>
                Uploaded files
            </h3>
            <div className={!_versions.length ? 'no-uploads' : ''}>
                <ul>
                    {_versions.length ?
                        _versions.map((version, index) => {
                            const { file, isLoading } = version

                            const [name, createdAt] = isLoading ? [getRandomNameByIndex(index), '2018-11-14 10:48:28'] : [file.name, formatStandardDateTime(formatByTimeZone(version.created_at, null, true), null, false, ' •', true)]

                            const key = version.id || index

                            return (
                                <li
                                    key={key}
                                    className={isLoadingInitial ? 'loading' : ''}
                                    style={{
                                        animationDelay: (index / 10) + 's'
                                    }}
                                >
                                    <button
                                        onClick={_ => {
                                            if (isLoading) {
                                                return false
                                            }

                                            openPreviewModal(version)
                                        }}
                                    >
                                        {isLoading ?
                                            <span className='file-display'></span>
                                            :
                                            <FileDisplay
                                                animateOnRender={true}
                                                file={version}
                                            />
                                        }
                                        <div>
                                            <p dangerouslySetInnerHTML={{ __html: name }} />
                                            <span>
                                                {createdAt}
                                            </span>
                                        </div>
                                    </button>
                                </li>
                            )
                        })
                        :
                        <AlertBanner
                            title={`No uploads`}
                            body={`Nothing's been uploaded to this chat.`}
                        />
                    }
                    {(total > offset && !isLoadingInitial) &&
                        <li>
                            <LoadMore
                                canLoadMore={total > offset}
                                onClick={handleLoadMore}
                                type={'files'}
                                isLoading={isLoadingMore}
                            />
                        </li>
                    }
                </ul>
            </div>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        allVersions: state.account.entities.versions,
        allFiles: state.account.entities.files
    }
}

export default connect(mapStateToProps, {
    openModal,
    getChatVersions
})(BigChatFiles)


// WEBPACK FOOTER //
// ./src/components/big-chat/big-chat-files.jsx